import { useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LogoutConfirmation from "../components/LogoutConfirmation";
import PortalPopup from "../components/PortalPopup";
import DebtCollectionNav from "./DebtCollectionNav";
import { Menu, X } from "lucide-react";

const NavigationPanelLawyer = ({ navItems }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const openLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(true);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const openSettingPage = useCallback(() => {
    navigate("/setting-general");
  }, []);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  // Create a modified version of navItems for mobile view
  const mobileNavItems = navItems.map((item) => {
    // Check if this is the active path
    const isActive =
      location.pathname === item.path ||
      (item.path === "" && location.pathname === "/");

    // Return modified item with:
    // - Active state text color change
    // - Consistent background color for all items
    return {
      ...item,
      bgColor: "bg-neutrals-neutral-50", // Set background color for all items
      textColor: isActive ? "text-primary-primary-500" : item.textColor, // Only change text color if active
    };
  });

  return (
    <>
      <div className="z-10 w-full relative bg-neutrals-neutral-50 box-border flex flex-col md:flex-row items-start md:items-center justify-between py-4 md:py-8 px-4 lg:px-24 text-left text-base text-neutrals-neutral-300 font-open-sans-ff-body-strong border-b-[1px] border-solid border-neutrals-neutral-100">
        <div className="w-full md:w-auto flex flex-row items-center justify-between md:justify-start md:gap-[51px]">
          <img src="assets/main-logo.svg" className="h-14" />

          {/* Desktop Navigation - aligned with logo */}
          <div className="hidden md:block">
            <DebtCollectionNav navItems={navItems} />
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden bg-transparent" onClick={toggleNavbar}>
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Desktop System Icons */}
        <div className="hidden md:flex flex-row items-center justify-end gap-[6px]">
          <div
            className="rounded-3xs bg-neutrals-neutral-50 flex flex-row items-start justify-start p-2.5 cursor-pointer"
            onClick={openSettingPage}
          >
            <img className="w-5 relative h-5" alt="" src="assets/setting.svg" />
          </div>
          {/* <div className="rounded-3xs bg-neutrals-neutral-50 flex flex-row items-start justify-start p-2.5">
            <div className="flex flex-row items-start justify-start relative gap-[10px]">
              <img
                className="w-5 relative h-5 z-[0]"
                alt=""
                src="assets/notification.svg"
              />
              <div className="w-2.5 absolute !m-[0] top-[0px] left-[10px] rounded-[50%] bg-semantics-high-high-500 box-border h-2.5 z-[1] border-[1.5px] border-solid border-neutrals-neutral-50" />
            </div>
          </div> */}
          <div
            className="flex flex-row items-start justify-end p-2.5 cursor-pointer"
            onClick={openLogoutConfirmation}
          >
            <img className="w-5 relative h-5" alt="" src="assets/logout.svg" />
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden w-full flex flex-col items-center mt-4 space-y-4">
            {/* Pass mobileNavItems to DebtCollectionNav for mobile view */}
            <DebtCollectionNav navItems={mobileNavItems} isMobile={true} />

            <div className="w-full flex flex-row items-center justify-around py-3 border-t border-neutrals-neutral-100">
              <div className="p-2 cursor-pointer" onClick={openSettingPage}>
                <img className="w-6 h-6" alt="" src="assets/setting.svg" />
              </div>
              <div className="p-2 relative">
                <img className="w-6 h-6" alt="" src="assets/notification.svg" />
                <div className="w-2.5 absolute top-[6px] right-[6px] rounded-full bg-semantics-high-high-500 box-border h-2.5 border-[1.5px] border-solid border-neutrals-neutral-50" />
              </div>
              <div
                className="p-2 cursor-pointer"
                onClick={openLogoutConfirmation}
              >
                <img className="w-6 h-6" alt="" src="assets/logout.svg" />
              </div>
            </div>
          </div>
        )}
      </div>

      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default NavigationPanelLawyer;
